import { SAML_INITIAL_STEP, SAML_STEPS } from './constants'

export const calculateCurrentStep = (ssoState) => SAML_STEPS[ssoState?.toUpperCase()] || SAML_INITIAL_STEP
